"use client";

import { SUPER_NAV_WIDTH } from "@constants/layouts";
import { Box, Flex, utils } from "@thenounproject/lingo-core";
import styled, { createGlobalStyle, DefaultTheme } from "styled-components";

type AppOverrideProps = {
  showSuperNav: boolean;
};
type AppBackgroundOverridesProps = AppOverrideProps & {
  theme: DefaultTheme;
};
export const AppBackgroundOverrides = createGlobalStyle<AppBackgroundOverridesProps>`
${props =>
  props.showSuperNav &&
  `
    body,html {
      background: ${utils.getColor("black")};
    }
`}`;
/**
 * Disables Inter font features if custom font is chosen.
 */
export const FontStyleOverrides = createGlobalStyle`
  ${props =>
    props?.theme?.fonts?.system?.family !== "Inter" &&
    `
    html, body {
      font-feature-settings: unset;
    }
  `}
`;

export const AppWrapper = styled.div<AppOverrideProps>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding-top: ${props => (props.showSuperNav ? "65px" : "0")};
  }
`;

export const LayoutContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  height: 0;
  width: 100%;
  align-items: stretch;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SuperNavContainer = styled(Flex).attrs({
  background: "black",
  borderRight: "1px solid black",
  height: "100%",
  flex: `0 0 ${SUPER_NAV_WIDTH}px`,
  overflow: "visible",
})`
  -webkit-overflow-scrolling: touch;
`;

export const ContentWrapper = styled(Flex).attrs<AppOverrideProps>(props => ({
  height: "100%",
  flex: "1 1 auto",
  overflow: "auto",
  borderRadius: props.showSuperNav ? `4px 0 0 4px` : "0",
  flexDirection: "column",
  variations: {
    "mq.s": {
      height: 0,
    },
  },
}))<AppOverrideProps>`
  @media (max-width: 768px) {
    border-radius: 4px 4px 0 4px;
  }
`;

export const ContentArea = styled(Box).attrs({
  flex: "1",
  width: "100%",
  overflow: "auto",
  background: "white",
})``;
